var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalyze(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.49948C4 4.94636 4.44727 4.49948 5 4.49948C5.55273 4.49948 6 4.94636 6 5.49948V11.4995C6 12.0526 5.55273 12.4995 5 12.4995C4.44727 12.4995 4 12.0526 4 11.4995V5.49948Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.49948C7.44727 7.49948 7 7.94636 7 8.49948V11.4995C7 12.0526 7.44727 12.4995 8 12.4995C8.55273 12.4995 9 12.0526 9 11.4995V8.49948C9 7.94636 8.55273 7.49948 8 7.49948Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.49948C10 6.94636 10.4473 6.49948 11 6.49948C11.5527 6.49948 12 6.94636 12 7.49948V11.4995C12 12.0526 11.5527 12.4995 11 12.4995C10.4473 12.4995 10 12.0526 10 11.4995V7.49948Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0.499481H2C0.896484 0.499481 0 1.39635 0 2.49948V14.4995C0 15.6026 0.896484 16.4995 2 16.4995H14C15.1035 16.4995 16 15.6026 16 14.4995V2.49948C16 1.39635 15.1035 0.499481 14 0.499481ZM2 14.4995V2.49948H14V14.4995H2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyze);
export default __webpack_public_path__ + "static/media/analyze.0af361b79eb3227cba3dc8c032ddfe4d.svg";
export { ForwardRef as ReactComponent };